const checkboxStyles = theme => ({
  '.checkbox-wrapper': {
    display: 'flex',
    alignItems: 'flex-start',
  },

  // Force override of styles from AntD
  "form input[type='checkbox'].checkbox-peer": {
    width: '16px',
    height: '16px',
  },

  '.checkbox': {
    display: 'flex',
    alignItems: 'center',
    width: '16px',
    height: '16px',
    // Use box-shadow instead of border to avoid affecting overall size
    border: 'none',
    borderRadius: '2px',
    color: 'transparent',
    backgroundColor: 'transparent',
  },

  '.checkbox-dark': {
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.65')}`,

    '.checkbox-peer:focus ~ &': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.65')}`,
    },

    '.checkbox-peer:checked ~ &': {
      color: theme('colors.white'),
      backgroundColor: theme('colors.green1.65'),
    },

    '.checkbox-peer:disabled ~ &': {
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.35')}`,
    },

    '.checkbox-peer:checked:disabled ~ &': {
      backgroundColor: theme('colors.green1.35'),
    },
  },

  '.checkbox-light': {
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.10')}`,

    '.checkbox-peer:focus ~ &': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.10')}`,
    },

    '.checkbox-peer:checked ~ &': {
      color: theme('colors.green1.60'),
      backgroundColor: theme('colors.green1.10'),
    },

    // TODO: disabled styles
  },

  '.checkbox-label': {
    paddingLeft: '14px',
    marginTop: '-1px',
    color: theme('colors.grey.75'),
    cursor: 'pointer',

    '.checkbox-peer:disabled ~ &': {
      color: theme('colors.grey.40'),
      cursor: 'not-allowed',
    },
  },
});

module.exports = { checkboxStyles };
